import Vue from 'vue'
import Router from 'vue-router'
import { GLOBAL } from '../common/global.func.js';
import routesR from './routerR';
Vue.use(Router)

const routes = new Router({
    base: process.env.BASE_URL,
    routes: routesR.concat([    {
        path: '/404',
        name: '404 Not Found',
        component: () => import('../pages/404')
    },
    {
        path: '/unauth',
        name: '未授权',
        component: () => import('../pages/unauth')
    },
    {
        path: '',
        redirect: '/index'
    },
    {
        path: '/login',
        name: '用户登录',
        component: () => import( '../pages/home/login'),
    },
    {
        path: '*',
        redirect: '/404'
    }])
})

routes.beforeEach((to, from, next) => {

    // console.log(store.state, "state", isLogin, from, to)
    // console.log(from, to, "to, from, next")
    const isAccess = GLOBAL.checkAccessAble(to.path);
    let public_route = ['/login','/404','/unauth'];
    if (public_route.indexOf(to.path) != -1) {
        next();
    } else {
        if (isAccess == 1) {
            next()
        } else if(isAccess == 0) {
            next({
                path: '/login',
                query: { redirect: to.fullPath }
            })
        }else if(isAccess == 2){
            next({
                path: '/unauth',
                query: {}
            })
        }
    }
})

export default routes
